import type { Choice, EventStatus, VotingView } from './types.ts';

/** "23 oct 2026, 18:45". (dateStyle no se puede combinar con hour/minute: Intl lanza TypeError.) */
export const formatDateTime = (date: Date | string, timeZone?: string) => new Intl.DateTimeFormat('es-MX', {
  day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', ...(timeZone ? { timeZone } : {}),
}).format(new Date(date));

/** "1 voto", "2 votos". */
export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export const CHOICE: Record<Choice, string> = { for: 'A favor', against: 'En contra', abstain: 'Abstención' };

export const EVENT_STATUS: Record<EventStatus, string> = {
  scheduled: 'Programada', in_session: 'En sesión', adjourned: 'Levantada',
};

export type PillKind = '' | 'live' | 'ok' | 'bad' | 'warn';

/** Texto y estilo de la píldora de estado de una votación. */
export function votingPill(v: Pick<VotingView, 'state' | 'result'> | null): { text: string; kind: PillKind } {
  if (!v) return { text: 'Sin votación abierta', kind: '' };
  if (v.state === 'voting') return { text: 'Votación abierta', kind: 'live' };
  if (v.state === 'closing') return { text: 'Empate: falta el voto de calidad', kind: 'warn' };
  const status = v.result?.status;
  if (status === 'approved') return { text: 'Aprobada', kind: 'ok' };
  if (status === 'rejected') return { text: 'Rechazada', kind: 'bad' };
  if (status === 'no-quorum') return { text: 'Sin quórum: no tiene efecto', kind: 'warn' };
  return { text: 'Empate: se repite la votación', kind: 'warn' };
}

/** Un asunto se puede volver a votar tras un empate a repetir o una votación sin quórum. */
export const canRevote = (status: string | null | undefined) => status === 'repeat' || status === 'no-quorum';

/**
 * Aviso para la presidencia mientras se vota, según la regla de quórum al cerrar de la votación.
 * null si no hay nada que advertir.
 */
export function quorumWarning(
  voting: Pick<VotingView, 'state' | 'ballotsCast' | 'quorumAtClose'> | null, presentNow: number,
): { text: string; kind: 'error' | 'notice' } | null {
  if (!voting || voting.state !== 'voting') return null;
  const { rule, need } = voting.quorumAtClose;
  if (rule === 'ballots' && voting.ballotsCast < need) {
    return { kind: 'notice', text: `Para que la votación tenga efecto se necesitan al menos ${need} votos; van ${voting.ballotsCast}.` };
  }
  if (presentNow >= need) return null;
  if (rule === 'present') {
    return { kind: 'error', text: `Se perdió el quórum: hay ${presentNow} presentes y se necesitan ${need}. Si cierras ahora, la votación no tendrá efecto.` };
  }
  if (rule === 'none') {
    return { kind: 'notice', text: `Se perdió el quórum de asistencia (${presentNow} de ${need}). Con estas reglas el resultado cuenta igual; queda registrado en el acta.` };
  }
  return null;
}
